





























































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { GradesCollection, TestTypeItem, OtherTest } from '@/modules/recordControl';
import { GradesTypes, getGradesTypeName } from '@/enums/gradesTypes';
import { SchoolTypes, getSchoolTypeName } from '@/enums/schoolTypes';
import { SchoolTerms, getSchoolTermName } from '@/enums/schoolTerms';
import { Subject } from '@/models/subject';
import { ElForm } from 'element-ui/types/form';
import { UserTypes } from '@/enums/userTypes';
import store from '@/store';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';

interface OtherTestEdit {
  editType: number; // 0:追加　1:編集　2:年回追加　3:年回編集
  gradesCollectionId: string;
  testTypeName: string;
  fiscalYear: Date | null;
  testTimes: number;
  testDay: Date | null;
  schoolType: SchoolTypes;
  subjectList: Subject[];
}

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component
export default class RecordControlList extends AvaivaledVue {
  private GradesTypes = GradesTypes;
  private getGradesTypeName = getGradesTypeName;
  private SchoolTypes = SchoolTypes;
  private getSchoolTypeName = getSchoolTypeName;
  private SchoolTerms = SchoolTerms;
  private getSchoolTermName = getSchoolTermName;

  private formRule = {
    testTypeName: [
      { required: true, message: 'その他テスト名を入力してください' },
    ],
    fiscalYear: [
      { required: true, message: '年度を入力してください' },
    ],
    testTimes: [
      { required: true, message: '回次を入力してください' },
    ],
    testDay: [
      { required: true, message: '実施日を入力してください' },
    ],
    schoolType: [
      { required: true, message: '学校区分を入力してください' },
    ],
    subjectList: [
      { required: true, message: '成績を収集する教科を選択してください' },
      { validator: this.validateSubjectList, trigger: 'blur' },
    ],
  };

  private deleteFormRule = {
    checkTestName: [
      { required: true, message: '削除するテスト名を入力してください' },
      { validator: this.validateCheckTestName, trigger: 'blur' },
    ],
  };

  private validateSubjectList(rule: any, value: string, callback: any, source: any) {
    const subjectList = source.subjectList as Subject[];
    if (subjectList.length === 0) {
      callback(new Error('成績を収集する教科を選択してください'));
    } else {
      callback();
    }
  }

  private validateCheckTestName(rule: any, value: string, callback: any) {
    const testName = ((this.$refs.otherTestDelete as DialogWrapper).form as any).testName;
    if (value.replace(/\s+/g, '') === testName.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('テスト名が異なります'));
    }
  }

  get loading(): boolean {
    return this.$store.state.recordControl.loading;
  }

  get schoolRecordCollection(): GradesCollection[] {
    return this.$store.getters['recordControl/schoolRecordCollection'];
  }

  get otherTestCollection(): OtherTest[] {
    return this.$store.getters['recordControl/otherTestCollection'];
  }

  get testTypeList(): TestTypeItem[] {
    return this.$store.getters['recordControl/testTypeList'];
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['auth/userType']) {
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        next();
        break;
      default:
        next({ name: 'Error' });
        break;
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('recordControl/fetchGradesCollectionList');
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Grade);
  }

  private formatLastSendDay(row: GradesCollection) {
    const schoolTerm = !row.schoolTerm ? 0 : row.schoolTerm;
    const sendMessage = row.sendMessages.find((send) => send.schoolTerm === schoolTerm);
    if (!sendMessage) {
      return '未配信';
    } else {
      return (this as any).$moment(sendMessage.lastSendDay).format('YYYY/MM/DD HH:mm配信');
    }
  }

  private schoolRecordCellStyle({ column }: any) {
    switch (column.property) {
      case 'edit':
        return null;
      default:
        return { cursor: 'pointer' };
    }
  }

  private otherTestCellStyle({ column }: any) {
    switch (column.property) {
      case 'edit':
      case 'addTestTimes':
        return null;
      default:
        return { cursor: 'pointer' };
    }
  }

  private onRowClickSchoolRecord(row: GradesCollection, column: any) {
    switch (column.property) {
      case 'edit':
        break;
      default:
        (this.$refs.schoolRecord as any).toggleRowExpansion(row);
        break;
    }
  }

  private onRowClickOtherTest(row: OtherTest, column: any) {
    switch (column.property) {
      case 'edit':
      case 'addTestTimes':
        break;
      default:
        (this.$refs.otherTest as any).toggleRowExpansion(row);
        break;
    }
  }

  // 内申点、定期テスト編集
  private submitSchoolRecord() {
    (this.$refs.schoolRecordForm as any).validate((valid: any) => {
      if (valid) {
        (this.$refs.schoolRecordEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onEditSchoolRecord(row: GradesCollection) {
    let form: GradesCollection;
    try {
      form = await this.$store.dispatch('recordControl/getGradesCollection', row.gradesCollectionId);
    } catch (error) {
      form = JSON.parse(JSON.stringify(row));
    }

    let result: GradesCollection;
    try {
      result = await (this.$refs.schoolRecordEdit as DialogWrapper).open({...form}) as GradesCollection;
    } catch (error) {
      return;
    }

    const gradesTypeName = getGradesTypeName(row.gradesType);
    const schoolTypeName = getSchoolTypeName(row.schoolType);
    const target = `${gradesTypeName}　${schoolTypeName}`;
    try {
      await this.$store.dispatch('recordControl/editGradesCollection', result);
      this.$notify({
        title: '変更完了',
        message: `<strong>${target}</strong><br>の教科を変更しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      this.$notify({
        title: 'エラー',
        message: `<strong>${target}</strong><br>の教科の変更に失敗しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    }
  }

  // その他テスト追加
  private getOtherTestEditTitle(form: OtherTestEdit) {
    switch (form.editType) {
      case 1:
        return 'その他テスト編集';
      case 2:
        return `${form.testTypeName}　年回追加`;
      case 3:
        return `${form.testTypeName}　年回編集`;
      default: // case 4
        return 'その他テスト追加';
    }
  }

  private submitOtherTest() {
    (this.$refs.otherTestForm as any).validate((valid: any) => {
      if (valid) {
        (this.$refs.otherTestEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onAddOtherTest() {
    const form: OtherTestEdit = {
      editType: 0,
      gradesCollectionId: '',
      testTypeName: '',
      fiscalYear: null,
      testTimes: 1,
      testDay: null,
      schoolType: SchoolTypes.ElementarySchool,
      subjectList: new Array<Subject>(),
    };

    let result: OtherTestEdit;
    try {
      result = await (this.$refs.otherTestEdit as DialogWrapper).open({...form}) as OtherTestEdit;
    } catch (error) {
      return;
    }

    const testTypeName = result.testTypeName;
    const testType = this.testTypeList.find((item) => {
      return item.value === testTypeName;
    });

    const data: GradesCollection = {
      gradesCollectionId: result.gradesCollectionId,
      gradesType: GradesTypes.OtherTest,
      gradesName: getGradesTypeName(GradesTypes.OtherTest),
      schoolType: result.schoolType,
      schoolTypeName: getSchoolTypeName(result.schoolType),
      testType: !testType ? '' : testType.id,
      testTypeName,
      fiscalYear: (result.fiscalYear as Date).getFullYear(),
      testTimes: result.testTimes,
      testTimesName: '',
      testDay: result.testDay as Date,
      subjectList: result.subjectList,
      sendMessages: [],
      schoolTerm: null,
    };

    const testName = data.testTypeName;
    const fiscalYear = `${data.fiscalYear}年度`;
    const testTimes = `第${data.testTimes}回`;
    const target = `${testName}<br>${fiscalYear}　${testTimes}`;
    try {
      await this.$store.dispatch('recordControl/createGradesCollection', data);
      this.$notify({
        title: 'その他テスト登録完了',
        message: `<strong>${target}</strong><br>を登録しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      this.$notify.error({
        title: 'その他テスト登録エラー',
        message: error.message,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
      return;
    }

    this.loadData();
  }

  // その他テスト属性編集
  private async onEditOtherTestAttribute(row: GradesCollection) {
    let data: GradesCollection;
    try {
      data = await this.$store.dispatch('recordControl/getGradesCollection', row.gradesCollectionId);
    } catch (error) {
      data = JSON.parse(JSON.stringify(row));
    }

    const form: OtherTestEdit = {
      editType: 1,
      gradesCollectionId: data.gradesCollectionId,
      testTypeName: data.testTypeName,
      fiscalYear: new Date(data.fiscalYear, 1, 1),
      testTimes: data.testTimes,
      testDay: data.testDay,
      schoolType: data.schoolType,
      subjectList: data.subjectList,
    };

    let result: OtherTestEdit;
    try {
      result = await (this.$refs.otherTestEdit as DialogWrapper).open({...form}) as OtherTestEdit;
    } catch (error) {
      return;
    }

    data = {
      gradesCollectionId: result.gradesCollectionId,
      gradesType: GradesTypes.OtherTest,
      gradesName: getGradesTypeName(GradesTypes.OtherTest),
      schoolType: result.schoolType,
      schoolTypeName: getSchoolTypeName(result.schoolType),
      testType: row.testType,
      testTypeName: result.testTypeName,
      fiscalYear: (result.fiscalYear as Date).getFullYear(),
      testTimes: result.testTimes,
      testTimesName: '',
      testDay: result.testDay as Date,
      subjectList: result.subjectList,
      sendMessages: [],
      schoolTerm: null,
    };

    const testName = data.testTypeName;
    const fiscalYear = `${data.fiscalYear}年度`;
    const testTimes = `第${data.testTimes}回`;
    const target = `${testName}<br>${fiscalYear}　${testTimes}`;
    try {
      await this.$store.dispatch('recordControl/editOtherTestAttribute', data);
      this.$notify({
        title: 'その他テスト変更完了',
        message: `「${testName}」を変更しました。`,
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: 'その他テスト変更エラー',
        message: error.message,
        position: 'bottom-right',
      });
    }
  }

  // その他テスト年回追加
  private async onAddOtherTestTimes(row: GradesCollection) {
    let data: GradesCollection;
    try {
      data = await this.$store.dispatch('recordControl/getGradesCollection', row.gradesCollectionId);
    } catch (error) {
      data = JSON.parse(JSON.stringify(row));
    }

    const form: OtherTestEdit = {
      editType: 2,
      gradesCollectionId: data.gradesCollectionId,
      testTypeName: data.testTypeName,
      fiscalYear: new Date(data.fiscalYear, 1, 1),
      testTimes: data.testTimes + 1,
      testDay: data.testDay,
      schoolType: data.schoolType,
      subjectList: data.subjectList,
    };

    let result: OtherTestEdit;
    try {
      result = await (this.$refs.otherTestEdit as DialogWrapper).open({...form}) as OtherTestEdit;
    } catch (error) {
      return;
    }

    data = {
      gradesCollectionId: result.gradesCollectionId,
      gradesType: GradesTypes.OtherTest,
      gradesName: getGradesTypeName(GradesTypes.OtherTest),
      schoolType: result.schoolType,
      schoolTypeName: getSchoolTypeName(result.schoolType),
      testType: data.testType,
      testTypeName: result.testTypeName,
      fiscalYear: (result.fiscalYear as Date).getFullYear(),
      testTimes: result.testTimes,
      testTimesName: '',
      testDay: result.testDay as Date,
      subjectList: result.subjectList,
      sendMessages: [],
      schoolTerm: null,
    };

    const testName = data.testTypeName;
    const fiscalYear = `${data.fiscalYear}年度`;
    const testTimes = `第${data.testTimes}回`;
    const target = `${testName}<br>${fiscalYear}　${testTimes}`;
    try {
      await this.$store.dispatch('recordControl/createOtherTestTimes', data);
      this.$notify({
        title: 'その他テスト年回登録完了',
        message: `<strong>${target}</strong><br>を変更しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      this.$notify.error({
        title: 'その他テスト年回登録エラー',
        message: error.message,
        position: 'bottom-right',
      });
      return;
    }

    this.loadData();
  }

  // その他テスト年回編集
  private async onEditOtherTestTimes(row: GradesCollection) {
    let data: GradesCollection;
    try {
      data = await this.$store.dispatch('recordControl/getGradesCollection', row.gradesCollectionId);
    } catch (error) {
      data = JSON.parse(JSON.stringify(row));
    }

    const form: OtherTestEdit = {
      editType: 3,
      gradesCollectionId: data.gradesCollectionId,
      testTypeName: data.testTypeName,
      fiscalYear: new Date(data.fiscalYear, 1, 1),
      testTimes: data.testTimes,
      testDay: data.testDay,
      schoolType: data.schoolType,
      subjectList: data.subjectList,
    };

    let result: OtherTestEdit;
    try {
      result = await (this.$refs.otherTestEdit as DialogWrapper).open({...form}) as OtherTestEdit;
    } catch (error) {
      return;
    }

    const testTypeName = result.testTypeName;
    const testType = this.testTypeList.find((item) => {
      return item.value === testTypeName;
    });

    data = {
      gradesCollectionId: result.gradesCollectionId,
      gradesType: GradesTypes.OtherTest,
      gradesName: getGradesTypeName(GradesTypes.OtherTest),
      schoolType: result.schoolType,
      schoolTypeName: getSchoolTypeName(result.schoolType),
      testType: !testType ? '' : testType.id,
      testTypeName,
      fiscalYear: (result.fiscalYear as Date).getFullYear(),
      testTimes: result.testTimes,
      testTimesName: '',
      testDay: result.testDay as Date,
      subjectList: result.subjectList,
      sendMessages: [],
      schoolTerm: null,
    };

    const testName = data.testTypeName;
    const fiscalYear = `${data.fiscalYear}年度`;
    const testTimes = `第${data.testTimes}回`;
    const target = `${testName}<br>${fiscalYear}　${testTimes}`;
    try {
      await this.$store.dispatch('recordControl/editOtherTestTimes', data);
      this.$notify({
        title: 'その他テスト年回変更完了',
        message: `<strong>${target}</strong><br>を変更しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      this.$notify.error({
        title: 'その他テスト年回変更エラー',
        message: error.message,
        position: 'bottom-right',
      });
    }
  }

  private submitDeleteForm() {
    (this.$refs.deleteForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.otherTestDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onDeleteOtherTest(form: OtherTestEdit) {
    const testName = form.testTypeName;
    const fiscalYear = `${(form.fiscalYear as Date).getFullYear()}年度`;
    const testTimes = `第${form.testTimes}回`;
    const target = `${testName}<br>${fiscalYear}　${testTimes}`;

    try {
      const confirm = {
        testName,
        testTimes: `${fiscalYear}　${testTimes}`,
        checkTestName: '',
      };
      await (this.$refs.otherTestDelete as DialogWrapper).open({...confirm});
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('recordControl/deleteGradesCollection', form.gradesCollectionId);
      this.$notify({
        title: '削除完了',
        message: `<strong>${target}</strong><br>を削除しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
      (this.$refs.otherTestEdit as DialogWrapper).close();
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    }
  }

  // 内申点、定期テスト　成績入力お願いメッセージ編集
  private onRequestSchoolRecordEdit(row: GradesCollection) {
    this.$router.push({
      name: 'RecordControlEdit',
      params: {
        gradesCollectionId: String(row.gradesCollectionId),
        semester: !row.schoolTerm ? '0' : String(row.schoolTerm),
      }
    });
  }

  // その他テスト　成績入力お願いメッセージ編集
  private onRequestOtherTest(row: GradesCollection) {
    this.$router.push({
      name: 'RecordControlEdit',
      params: {
        gradesCollectionId: String(row.gradesCollectionId),
        semester: '0',
      }
    });
  }
}
